import { Component, inject, Input } from '@angular/core';
import { NgIcon, provideNgIconLoader, withCaching } from "@ng-icons/core";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-unavailable-page',
  imports: [NgIcon],
  templateUrl: './unavailable-page.component.html',
  styleUrls: ['./unavailable-page.component.scss'],
  standalone: true,
  providers: [
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ]
})
export class UnavailablePageComponent {
  @Input() public title: string = 'Page is unavailable';
  @Input() public description: string = 'Glimpse period is expired.\n' +
    'Please Create an Account to see the story!';
}
